import { type Repub } from '~/vendor/cx-modules/constants';

import { PLUS_REPUB_CONFIG } from './plus-tools-repub-config';

export const getPlusLinks = ({
  isTipstersEnabled,
  repub,
  urlPrefix,
}: {
  isTipstersEnabled: boolean;
  repub: Repub;
  urlPrefix: string;
}) => {
  const links = PLUS_REPUB_CONFIG[repub]?.navigation?.plusLinks(urlPrefix) ?? [];

  return links.filter(link => {
    if (link.showWhenTipstersEnabled === true) return isTipstersEnabled; // Show tipsters link when the feature flag is enabled.
    if (link.showWhenTipstersEnabled === false) return false; // Explicitly disable tipsters for this repub.
    return true; // No tipsters setting (undefined) - always show the link.
  });
};
